module.exports = __webpack_public_path__ + "img/timer_pause_outlined.84f9b3d9.svg";